import React, { useState, useEffect } from 'react';
import { api } from '../services/api';
import TaskItem from './TaskItem';
import TaskForm from './TaskForm';
import Categories from './Categories';
import '../styles/Dashboard.css';

// Composant principal du tableau de bord (après connexion)
function Dashboard({ setToken }) {
  // Liste des tâches et catégories
  const [tasks, setTasks] = useState([]);
  const [cats, setCats] = useState([]);
  // ID de la tâche en cours d'édition
  const [editingTaskId, setEditingTaskId] = useState(null);

  // Etats pour les filtres
  const [search, setSearch] = useState(''); // Recherche par titre
  const [filterStatus, setFilterStatus] = useState('all'); // Filtre par statut
  const [filterDate, setFilterDate] = useState('all'); // Filtre par date

  // Charge toutes les données au démarrage
  useEffect(() => { loadAll(); }, []);

  // Charge les tâches et catégories depuis l'API
  const loadAll = async () => {
    try {
      const t = await api.getTasks();
      const c = await api.getCats();
      setTasks(t.data);
      setCats(c.data);
    } catch (e) { if(e.response?.status===401) logout(); } // Déconnexion si token invalide
  };

  // Déconnexion : supprime le token et retourne à la page login
  const logout = () => { localStorage.removeItem('user_token'); setToken(null); };

  // Ajoute une nouvelle tâche puis recharge la liste
  const handleAddTask = async (taskData) => { await api.addTask(taskData); loadAll(); };
  
  // Change le statut d'une tâche (pending <-> completed)
  const toggleTask = async (t) => {
    await api.updateTask({ ...t, status: t.status==='pending'?'completed':'pending' });
    loadAll();
  };

  // Supprime une tâche après confirmation
  const delTask = async (id) => { if(window.confirm('Voulez-vous supprimer cette tâche ?')) { await api.deleteTask(id); loadAll(); } };

  // Filtre les tâches selon les critères sélectionnés
  const filtered = tasks.filter(t => {
    // Filtre par statut (pending/completed)
    if(filterStatus !== 'all' && t.status !== filterStatus) return false;
    
    // Filtre par recherche dans le titre
    if(search && !t.title.toLowerCase().includes(search.toLowerCase())) return false;
    
    // Filtre par date (aujourd'hui/cette semaine/en retard)
    if(filterDate !== 'all' && t.due_date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const taskDate = new Date(t.due_date);
      taskDate.setHours(0, 0, 0, 0);
      
      // Calcule la différence en jours
      const diffTime = taskDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      if(filterDate === 'today' && diffDays !== 0) return false; // Aujourd'hui
      if(filterDate === 'week' && (diffDays < 0 || diffDays > 7)) return false; // Cette semaine
      if(filterDate === 'overdue' && diffDays >= 0) return false; // En retard
    }
    
    return true; // Tâche passée tous les filtres
  });

  return (
    <div className="container">
      <header className="header">
        <div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
          <img src={require('../assets/logo-nobg.png')} alt="AnList Logo" style={{width: '50px', height: '50px'}} />
          <h2>AnList</h2>
        </div>
        <button onClick={logout}>Déconnexion</button>
      </header>

      <div className="dashboard-layout">
        {/* Sidebar gauche - Création tâche et catégories */}
        <aside className="dashboard-sidebar">
          <TaskForm cats={cats} onAddTask={handleAddTask} />
          <Categories cats={cats} loadAll={loadAll} />
        </aside>

        {/* Contenu principal - Liste des tâches */}
        <main className="dashboard-main">
          <div className="box">
            <h3>Mes Tâches</h3>
        <div className="filters-container">
            <input 
              placeholder="🔍 Recherche..." 
              value={search} 
              onChange={e=>setSearch(e.target.value)}
              className="filter-search"
            />
            <select 
              onChange={e=>setFilterStatus(e.target.value)}
              className="filter-select"
            >
                <option value="all">Tout</option>
                <option value="pending">En cours</option>
                <option value="completed">Terminées</option>
            </select>
            <select 
              onChange={e=>setFilterDate(e.target.value)}
              className="filter-select"
            >
                <option value="all">Toutes les dates</option>
                <option value="today">Aujourd'hui</option>
                <option value="week">Cette semaine</option>
                <option value="overdue">En retard</option>
            </select>
        </div>

        {filtered.map(t => (
          <TaskItem 
            key={t.id} 
            task={t} 
            cats={cats}
            isEditing={editingTaskId === t.id}
            setEditingTaskId={setEditingTaskId}
            toggleTask={toggleTask}
            delTask={delTask}
            loadAll={loadAll}
          />
        ))}
          </div>
        </main>
      </div>
    </div>
  );
}

export default Dashboard;